import { render, staticRenderFns } from "./Turnos.vue?vue&type=template&id=b768e054&scoped=true&"
import script from "./Turnos.vue?vue&type=script&lang=js&"
export * from "./Turnos.vue?vue&type=script&lang=js&"
import style0 from "./Turnos.vue?vue&type=style&index=0&id=b768e054&prod&scoped=true&lang=css&"
import style1 from "./Turnos.vue?vue&type=style&index=1&id=b768e054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b768e054",
  null
  
)

export default component.exports